import type { PlatformPermissionKey } from '@/shared/api/platform';
import type { IconName } from '@/shared/components/Icon';

/**
 * Own menu of the platform area (13 §3.4, `AM-134` point 11): six entries, none of them shared
 * with the tenant console's manifest - the two surfaces never mix (ISO-24).
 */
export interface PlatformNavItem {
  labelKey: string;
  to: string;
  icon: IconName;
  /** The key its main `GET` requires (08 §6.2); omitted for the summary, whose own cards degrade. */
  permission?: PlatformPermissionKey;
}

export const PLATFORM_NAV_ITEMS: readonly PlatformNavItem[] = [
  { labelKey: 'platform:nav.summary', to: '/platform', icon: 'home' },
  {
    labelKey: 'platform:nav.tenants',
    to: '/platform/tenants',
    icon: 'briefcase',
    permission: 'platform.tenants.view',
  },
  {
    labelKey: 'platform:nav.supportAccess',
    to: '/platform/support-access',
    icon: 'link',
    permission: 'platform.support_access.request',
  },
  {
    labelKey: 'platform:nav.audit',
    to: '/platform/audit',
    icon: 'history',
    permission: 'platform.audit.view',
  },
  {
    labelKey: 'platform:nav.featureFlags',
    to: '/platform/feature-flags',
    icon: 'settings',
    permission: 'platform.feature_flags.manage',
  },
  // The manual's chapter for whoever operates the installation: nobody needs a permission to read it.
  { labelKey: 'platform:nav.help', to: '/platform/ayuda', icon: 'help' },
];
